import {Component, Input} from "@angular/core";
import {SavedSearchesItemModel} from "../../models/saved-searches-item.model";
import {SavedSearchesService} from "../../services/saved-searches.service";

@Component({
    selector: "pcg-ng-saved-searches-item-card",
    template: require('./saved-searches-item-card.component.html')
})
export class SavedSearchesItemCardComponent {
    public isOpen: boolean = false;
    @Input()
    public itemToDisplay: SavedSearchesItemModel;

    public constructor(
        private _searchService: SavedSearchesService
    ) {
    }
    public onEditCardButtonClicked(): void {
        this.isOpen = !this.isOpen;
    }
    public onRemoveCardButtonClicked(): void {
        this._searchService.deleteSavedSearch(this.itemToDisplay.id);
    }
    public onSaveCardButtonClicked(name: string): void {
        this.itemToDisplay.name = name;
        this._searchService.updateSavedSearch(this.itemToDisplay);
        this.isOpen = !this.isOpen;
    }
}
